module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "编辑系统角色",
      "center": true,
      "visible": _vm.editVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.editVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "update-body"
  }, [_c('el-form', {
    ref: "submitForm",
    staticClass: "update-body-form",
    attrs: {
      "model": _vm.submitData,
      "rules": _vm.validatorRules,
      "label-width": "100px"
    }
  }, [_c('div', {
    staticClass: "update-body-div"
  }, [_c('div', {
    staticClass: "update-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "角色名称",
      "prop": "roleName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写-角色名称"
    },
    model: {
      value: (_vm.submitData.roleName),
      callback: function($$v) {
        _vm.$set(_vm.submitData, "roleName", $$v)
      },
      expression: "submitData.roleName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "update-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "角色编码",
      "prop": "roleCode"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写-角色编码"
    },
    model: {
      value: (_vm.submitData.roleCode),
      callback: function($$v) {
        _vm.$set(_vm.submitData, "roleCode", $$v)
      },
      expression: "submitData.roleCode"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "update-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "描述信息",
      "prop": "roleRemark"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写-描述信息"
    },
    model: {
      value: (_vm.submitData.roleRemark),
      callback: function($$v) {
        _vm.$set(_vm.submitData, "roleRemark", $$v)
      },
      expression: "submitData.roleRemark"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "update-body-div"
  }, [_c('div', {
    staticClass: "update-item-view"
  }, [_c('el-form-item', {
    attrs: {
      "label": "权限信息"
    }
  }, [_c('el-tree', {
    ref: "permissionTree",
    attrs: {
      "data": _vm.permissionPageList,
      "show-checkbox": "",
      "node-key": "authPermissionId",
      "default-checked-keys": _vm.rolePermissionIdList,
      "props": _vm.treeProps,
      "check-strictly": ""
    },
    on: {
      "check-change": _vm.handleCheckChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑系统角色",
      "center": true,
      "visible": _vm.permissionVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.permissionVisible = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("提 交")])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3238939a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3238939a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/platform/auth-role/ItemEdit.vue
// module id = 1275
// module chunks = 1